// extracted by css-extract-rspack-plugin
var _1 = "E7CdXV8QQh0Gacws";
export { _1 as "overlay" }
